import { SalePoint, SalePointId } from '@/components/modules/Application/IberiaCards/_shared/types/SalePoint';

export const SALE_POINTS: SalePoint[] = [
  { literal: 'APP STAND BARNA', applicationOrigin: 1419, channelCode: 'Barcelona', id: SalePointId.BCN },
  { literal: 'APP Stand Madrid T2', applicationOrigin: 1425, channelCode: 'Madrid T2', id: SalePointId.MT2 },
  { literal: 'APP STAND MD', applicationOrigin: 1422, channelCode: 'Madrid T4', id: SalePointId.MT4 },
  { literal: 'STAND FERIAS INNERIA', applicationOrigin: 1424, channelCode: 'Ferias', id: SalePointId.FER },
  { literal: 'STANDS Sevilla', applicationOrigin: 1426, channelCode: 'Sevilla', id: SalePointId.SEV },
];
